import React from "react";
import { Card, CardContent, Typography, Box, Alert } from "@mui/material";
import EditableFields from "./EditableFields";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import "./Profile.css";

const ProfileInfo = ({ data, dataOriginal, handleFormChange, updateProfile }) => {
  return (
    <Card elevation={1} sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: { xs: 2, sm: 3 } }}>
          <PersonIcon color="primary" sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
            Personal Information
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <EditableFields
            label="First name"
            value={data?.first_name}
            fieldName="first_name"
            handleFormChange={handleFormChange}
            updateField={updateProfile}
          />
          <EditableFields
            label="Last name"
            value={data?.last_name}
            fieldName="last_name"
            handleFormChange={handleFormChange}
            updateField={updateProfile}
          />
          <EditableFields
            label="Email"
            value={data?.email}
            fieldName="email"
            handleFormChange={handleFormChange}
            updateField={updateProfile}
          />
          
          {dataOriginal.email !== data.email && (
            <Alert severity="warning" sx={{ borderRadius: 2 }}>
              Email will be changed only after clicking the confirmation link in your email.
            </Alert>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfileInfo;
